import './helpers.js';

import {MainApp} from './app/MainApp.js'
window.MainApp = MainApp;
